"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var JobField_1 = __importDefault(require("@features/ItemCommon/components/common/JobField"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var formatter_1 = require("@utils/formatter");
function ItemPriceEditable(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var job = _a.job, updatePrice = _a.updatePrice, domain = _a.domain, editPermissions = _a.editPermissions, automationListsPermission = _a.automationListsPermission, editMode = _a.editMode;
    var t = (0, react_i18next_1.useTranslation)().t;
    var price = (_d = (_c = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.price;
    // If price is undefined, don't render anything
    if (price === undefined) {
        return null;
    }
    // Convert price to empty string for the input if it's null or -1 (our special "empty" marker)
    var displayValue = price === null || price === -1 ? '' : price;
    var labelWithCurrency = "".concat(t('ITEM.PRICE'), " (").concat(((_g = (_f = (_e = job === null || job === void 0 ? void 0 : job.ad) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.priceCurrency) || '', ")");
    return (react_1.default.createElement("div", { className: "item-detail-job-price" },
        react_1.default.createElement(JobField_1.default, { cyName: "price", label: "".concat(t('ITEM.PRICE'), " (").concat(((_k = (_j = (_h = job === null || job === void 0 ? void 0 : job.ad) === null || _h === void 0 ? void 0 : _h.current) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.priceCurrency) || '', ")"), value: displayValue, setValue: function (value) {
                if (value === '') {
                    // Using -1 as a marker for "empty price" since we need a number value
                    updatePrice(-1);
                }
                else {
                    var parsedValue = Number.parseFloat(value);
                    updatePrice(Number.isNaN(parsedValue) ? 0 : parsedValue);
                }
            }, domain: domain, isNotEditable: !editMode || !editPermissions.priceEditAllowed, minVal: 0, formatNumber: true, title: "".concat(labelWithCurrency, ": ").concat((0, formatter_1.thousandSeparator)(price)), automationListsPermission: automationListsPermission })));
}
exports.default = ItemPriceEditable;
